export const languages = [
  { displayValue: "English", dropdownDisplayValue: "English UK" },
];
